import { LocationQuery, useRoute } from 'vue-router'

import { nextStayTrail } from './stayTrail'

interface StayLinkOptions {
  targetStayLabel?: string | number | null
}

export function useStayTrail() {
  const route = useRoute()

  function stayLinkQuery(options: StayLinkOptions = {}): LocationQuery {
    const query: LocationQuery = { ...route.query }
    delete query.rumId
    delete query.externalRumId

    const trail = nextStayTrail(route.query.stayTrail, route.query.stayLabel)
    if (trail) {
      query.stayTrail = trail
    } else {
      delete query.stayTrail
    }

    const { targetStayLabel } = options
    if (targetStayLabel !== null && targetStayLabel !== undefined && String(targetStayLabel).length > 0) {
      query.stayLabel = String(targetStayLabel)
    } else {
      delete query.stayLabel
    }

    return query
  }

  return { stayLinkQuery }
}
